import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeAdminModal } from "store/slices/common/adminModal.slice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AdminModal = () => {
  const {
    isOpen,
    actions,
    content,
    title,
    maxWidth = "md",
  } = useSelector((state) => state.adminModal);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(closeAdminModal());
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      TransitionComponent={Transition}
      className="centerModel"
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: { maxWidth },          // kept exactly as before
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          bgcolor: "#fff",
          backgroundImage: "none",
          boxShadow: "none",
          padding: "20px",
          borderRadius: "8px",
          overflow: "hidden",              // prevents paper scroll
        },
      }}
    >
      <DialogContent
        className="no-scrollbar"
        sx={{
          p: 0,
          flex: "1 1 auto",
          overflowY: "auto",               // only content scrolls
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          className="flex items-center justify-between"
          sx={{ mb: 2, flexShrink: 0 }}
        >
          <Typography
            sx={{ fontWeight: 550, fontSize: "18px", color: "#0b0809" }}
          >
            {title}
          </Typography>
        </Box>

        <Box sx={{ flex: "1 1 auto" }}>
          {content}
        </Box>
      </DialogContent>

      {actions && (
        <DialogActions sx={{ flexShrink: 0, px: 0, pt: 2 }}>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default AdminModal;